// Copyright (c) 2022 by Move Closer

import { VueConstructor } from 'vue'

import { CreationAddon, ImageAddon, TimerAddon } from './addons'
import { PossibleAddon, PossibleAddons } from '../Hero.contracts'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const heroCarouselConfig = {
  autoHeight: true,
  autoplay: true,
  centralize: false,
  delay: 3000,
  hasPagination: true,
  hasButtons: false,
  initialSlide: 0,
  inLoop: true,
  pauseOnHover: true,
  perPage: 1
}

/**
 * Maps `AdoonType` to `VueConstructor`
 *
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const heroModuleAddonsUiRegistry: Record<PossibleAddon, VueConstructor> = {
  [PossibleAddons.Creations]: CreationAddon,
  [PossibleAddons.Image]: ImageAddon,
  [PossibleAddons.Timer]: TimerAddon
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const HERO_DEFAULT_CONFIG = {
  carouselConfig: heroCarouselConfig,
  hasBenefitsBar: true,
  linkDecorator: '',
  linkTheme: 'primary'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const HERO_COMPONENT_KEY = 'HeroModule'
